import { Box } from '@mui/material'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { Release } from '@api/models'

export const Dialog = ({ release }: { release: Release }) => {
  return (
    <Box
      sx={{
        minWidth: '50vw',
        maxWidth: '75vw',
        height: '80vh',
      }}
    >
      <Box sx={{ backgroundColor: 'background.paper', p: 2 }}>
        <Markdown remarkPlugins={[remarkGfm]}>{release.body}</Markdown>
      </Box>
    </Box>
  )
}
